import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function AboutStaffCTA() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-108">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-109">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-110">
          <span className="font-serif italic text-[#FF1493] text-xl mb-6 block" data-id="element-111">
            Our Promise
          </span>

          <p className="text-[#B0B0B0] text-base lg:text-lg leading-[1.8] font-body mb-12" data-id="element-112">
            Here at Be CLINICAL we focus on enhancing lives and making our
            patients happy by helping them reach their ideal weight or looking
            their best and offering the best and most effective solutions to get
            there. Rather than putting band-aids on problems with a quick-fix or
            waiting until things go wrong, we get ahead of the game with
            comprehensive and preventative aging. Whether you want to{' '}
            <strong className="text-[#FF1493]" data-id="element-113">Be SCULPTED</strong> or{' '}
            <strong className="text-[#FF1493]" data-id="element-114">Be YOUNG</strong>, Be CLINICAL
            can help!
          </p>

          <Button variant="primary" size="lg" className="px-10 py-4 text-sm tracking-[2px] rounded uppercase" data-id="element-115">
            MEET THE STAFF
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}